import { MOTION_EDITOR_RESOURCE_DOMAIN } from '../resources';

export const PLAYER_FRAME_RATE = 30;
export const CAMERA_DISTANCE_MULTIPLIER = 2;
export const DEFAULT_CAMERA_POSITION: [number, number, number] = [0, 4, 10];
export const PLAYER_ID = 'motion-editor-player';

export const PLAYER_INITIAL_SETTINGS = {
  playback: {
    frameRate: PLAYER_FRAME_RATE,
  },
  scene: {
    showActorNameTags: true,
  },
  environment: {
    backdropHexColor: '#5e97c5',
    useBackgroundGradient: false,
    showGrid: true,
    gridCellSize: 0.075,
    gridColor: '#83BDDE',
  },
};

export const DEFAULT_FALLBACK_BVH_URLS = [
  `${MOTION_EDITOR_RESOURCE_DOMAIN}/share/motions/default-animations1.bvh`,
  `${MOTION_EDITOR_RESOURCE_DOMAIN}/share/motions/default-animations2.bvh`,
  `${MOTION_EDITOR_RESOURCE_DOMAIN}/share/motions/default-animations3.bvh`,
];
